import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CheckoutSteps = ({ step1, step2, step3, step4 }) => {
  const { t } = useTranslation();

  return (
    <Nav className='checkout-steps justify-content-center mb-4'>
      <Nav.Item>
        {step1 ? (
          <Nav.Link as={Link} to='/login' className='active-step'>
            {t('signin')}
          </Nav.Link>
        ) : (
          <Nav.Link disabled>{t('signin')}</Nav.Link>
        )}
      </Nav.Item>

      <Nav.Item>
        {step2 ? (
          <Nav.Link as={Link} to='/shipping' className='active-step'>
            {t('shipping')}
          </Nav.Link>
        ) : (
          <Nav.Link disabled>{t('shipping')}</Nav.Link>
        )}
      </Nav.Item>

      <Nav.Item>
        {step3 ? (
          <Nav.Link as={Link} to='/payment' className='active-step'>
            {t('payement')}
          </Nav.Link>
        ) : (
          <Nav.Link disabled>{t('payement')}</Nav.Link>
        )}
      </Nav.Item>

      <Nav.Item>
        {step4 ? (
          <Nav.Link as={Link} to='/placeorder' className='active-step'>
            {t('placeorder')}
          </Nav.Link>
        ) : (
          <Nav.Link disabled>{t('placeorder')}</Nav.Link>
        )}
      </Nav.Item>
    </Nav>
  );
};

export default CheckoutSteps;
